import type { RendererProps } from './type';

import { Text } from '@shopify/polaris';

export const DateCell = ({ value, isMergedWithPrev }: RendererProps<string>) => (
  <Text as="span" variant="bodySm">
    {isMergedWithPrev ? '' : value}
  </Text>
);
